<template>
  <div id="nutrition" style="height: calc(100vh - 110.2969px);padding-bottom: 5rem">
    <div style="height: 100%;" class="d-flex align-items-center h-100 w-100">

      <div v-if="APPT_REQUESTED" class="video-call-wrapper">
        <n-button icon v-if="CARECO_JOINED" style="position: absolute;top: 1em;inset-inline-end: 2em;z-index: 1" round type="danger" size="lg" @click.native="cancelAppointment">
          <i class="now-ui-icons ui-1_simple-remove"></i>
        </n-button>

        <vmaatu v-if="CARECO_JOINED &&
            user.endpoint &&
            user.endpoint.videoConfEPType == 'VMAATU_RTC'
            " :query="simpleMeetingsQuery" ref="vmaatu"></vmaatu>
        <webex-teams v-if="CARECO_JOINED &&
            user.endpoint &&
            user.endpoint.videoConfEPType == 'WEBEXTEAMS_GUEST'
            " :query="simpleMeetingsQuery" ref="webex-teams"></webex-teams>

        <div v-if="!CARECO_JOINED" style="
                    position: absolute;
                    height: 100vh;
                    z-index: 1030;
                    width: 100%;
                    background: #ffffff;
                    display: grid;
                  ">
          <div class="text-center">
            <img style="margin-top: 3em; height: 45vh;" src="@/assets/img/bg2.svg" />
          </div>
          <div class="text-center" style="padding: 1em;">
            <h6>{{ $t("message.Kindly wait until a Coordinator answers your request...") }}</h6>
          </div>
          <div class="text-center">
            <n-button round type="danger" size="lg" @click.native="cancelAppointment" class="cancel-appt-request-button" v-if="APPT_REQUESTED">
              {{ $t("message.Cancel Request") }}
            </n-button>
          </div>
        </div>
      </div>

      <div class="row justify-content-center w-100">
        <div class="col-6">
          <card class="mt-2" style="background-blend-mode: darken;border-radius: 24px; height: 100%" card-body-classes="pt-0">
            <div class="row" style="margin-top:2em;">
              <div class="col-12" id="get-help">
                <h5 slot="header" class="card-title" style="font-weight: 600;font-size: 1.3em;">
                  {{ $t("message.Health assist") }}
                </h5>
                <div class="col-10" style="padding-inline-start: 0px;">{{ $t("message.Get quick access to assistance from care-coordinator") }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <n-button round size="lg" type="primary" @click.native="showCareCoDisclaimer()">
                  <i class="fas fa-hand-holding-heart pr-1"></i>
                  {{ $t("message.Get Help Now") }}
                </n-button>
              </div>
            </div>
          </card>
        </div>
      </div>

    </div>
    <call-notification v-if="callNotification" :caller="caller" :callType="'incoming'" @call-declined="onCallDeclined()" @call-accepted="onCallAccepted()" @call-missed="onCallMissed()">
    </call-notification>

    <!-- Care Coordinator Disclaimer -->
    <modal :show.sync="SHOW_CARECO_DISCLAIMER" headerclasses="justify-content-center" :showClose="false">
      <h4 slot="header" class="title title-up">
        {{ $t("message.Agree to proceed") }}
      </h4>
      <p>
        {{ $t("message.Please note that this request service allows audio and video information sent to the care coordinator during the session, which may be discoverable in a legal matter. By joining this session, you automatically consent to the same. If you do not consent, discuss your concerns with the administrator.") }}
      </p>
      <template slot="footer">
        <n-button @click.native="declineCarecoDiscailmer()" round>{{
          $t("message.Disagree")
        }}</n-button>
        <n-button type="primary" round @click.native="requestAppointment()">{{
          $t("message.Agree")
        }}</n-button>
      </template>
    </modal>

    <!-- Doctor Disclaimer -->
    <modal :show.sync="SHOW_DOCTOR_DISCLAIMER" headerclasses="justify-content-center" :showClose="false">
      <h4 slot="header" class="title title-up">
        {{ $t("message.Agree to proceed") }}
      </h4>
      <p v-html="settings.disclaimerText" v-if="settings"></p>
      <template slot="footer">
        <n-button @click.native="docDisclaimerDisagree()">{{
          $t("message.Disagree")
        }}</n-button>
        <n-button type="danger" @click.native="$router.push('telemed')">{{
          $t("message.Agree")
        }}</n-button>
      </template>
    </modal>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import { TabPane, Tabs, Collapse, CollapseItem, Modal } from "src/components";
import avatarImage from "@/assets/img/proAvatar.png";
import Profile from "./Profile.vue";
import BlogFeed from "./patient/BlogFeed.vue";

import {
  StatsCard,
  Switch,
  TimeLine,
  TimeLineItem,
  Table as NTable,
  Checkbox,
} from "src/components";
import { DatePicker } from "element-ui";
import { CoolSelect } from "vue-cool-select";
import { Carousel, Slide } from "vue-carousel";
// import Vmaatu from "../../pages/simplemeetings/Vmaatu.vue";
// import WebexTeams from "../../pages/simplemeetings/WebexTeams.vue";

import swal from "sweetalert2";
import Message from "src/pages/carenation/Message.vue";
import socket from "@/services/socket";
import moment from "moment-timezone";
import CallNotification from "../../components/CallNotification.vue";
import Bookings from "src/pages/carenation/Bookings.vue";
import Card from "../../components/Cards/Card.vue";

export default {
  name: "home",

  components: {
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    StatsCard,
    [Switch.name]: Switch,
    TimeLine,
    TimeLineItem,
    CallNotification,
    NTable,
    Checkbox,
    [DatePicker.name]: DatePicker,
    Message,
    Modal,
    CoolSelect,
    Carousel,
    Slide,
    Bookings,
    Card,
    Profile,
    BlogFeed,
    // Vmaatu,
    // WebexTeams,
  },

  data() {
    return {
      searchText: "",
      appointment: null,
      Authentication: {},
      currentPage: 0,
      cardName: null,
      cardDescription: null,
      careCoordinatorList: null,
      messageTextFilter: null,
      messageDateFilter: null,
      appointmentsDateFilter: new Date(),
      selectedMessage: null,
      APPT_REQUESTED: false,
      simpleMeetingsQuery: {},
      CREATE_NEW_MESSAGE: false,
      subject: null,
      selectedDoctor: null,
      doctorSearchText: "",
      filteredDoctorList: [],
      CARECO_JOINED: false,
      CARECARDS_LOADED: false,
      UNREAD_MESSAGE: true,
      unreadChatList: [],
      SHOW_VC: true,
      SHOW_MESSAGES_TAB: false,
      messages: [],
      scheduledAppointments: [],
      completedAppointments: [],
      SHOW_CARECO_DISCLAIMER: false,
      SHOW_DOCTOR_DISCLAIMER: false,
      workingHours: {},

      messagesPagination: {
        totalPages: 0,
        pageNumber: 1,
      },
      scheduledApptPagiantion: {
        totalPages: 0,
        pageNumber: 1,
      },
      completedApptPagiantion: {
        totalPages: 0,
        pageNumber: 1,
      },
      doctorSearchString: null,

      nursegroup: null,
      requestedServices: [],
      caller: {},
      callNotification: false,
      incomingCallAppt: {},
      appointmentMessages: [],
      SHOW_APPOINTMENT_ACTION_BUTTONS: false,
      SHOW_DOCTOR_MODAL: false,
      DOCTOR: null,
      previousAppointmentDoctors: [],
      deviceProfile: [],
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    endpoint() {
      return this.$store.state.endpoint;
    },
    FCMpayload() {
      return this.$store.state.FCMpayload;
    },
    latestPrescription() {
      return this.$store.state.latestPrescription;
    },
    patient() {
      return this.$store.state.patient;
    },
    filteredMessages() {
      if (this.messages) {
        return this.messages.filter((message) => {
          return (
            (!this.messageTextFilter ||
              (message.subject &&
                (message.subject
                  .toLowerCase()
                  .indexOf(this.messageTextFilter.toLowerCase()) > -1 ||
                  message.to.firstName
                    .toLowerCase()
                    .indexOf(this.messageTextFilter.toLowerCase()) > -1 ||
                  message.to.lastName
                    .toLowerCase()
                    .indexOf(this.messageTextFilter.toLowerCase()) > -1))) &&
            (!this.messageDateFilter ||
              moment(this.messageDateFilter).format("MMMM Do YYYY") ==
                moment(message.date).format("MMMM Do YYYY"))
          );
        });
      }
    },
    careGroupDetails() {
      if (this.$store.state.caregroup) {
        this.CARECARDS_LOADED = true;
        this.$store.state.caregroup.cards.sort(function (a, b) {
          return 0.5 - Math.random();
        });
      }
      return this.$store.state.caregroup;
    },
    settings() {
      return this.$store.state.settings;
    },
    doctorList() {
      return this.$store.state.doctorList;
    },
    locationTrackingEnabled() {
      return this.$store.state.locationTracking && BackgroundGeolocation;
    },
    activeTab() {
      return this.$store.state.homePageActiveTab;
    },
    isWorkingHours() {
      if (this.settings && this.settings.workingHours) {
        let start = Number(this.settings.workingHours.start);
        let end = Number(this.settings.workingHours.end);
        if (start > 12) {
          this.workingHours.start = start - 12 + " pm";
        } else {
          this.workingHours.start = start + " am";
        }
        if (end > 12) {
          this.workingHours.end = end - 12 + " pm";
        } else {
          this.workingHours.end = end + " am";
        }
        let format = "hh:mm:ss a";
        let currentTimeStr = moment(new Date()).format(format);
        let startTime = moment(this.settings.workingHours.start, format);
        let endTime = moment(this.settings.workingHours.end, format);
        let now = moment(currentTimeStr, format);

        if (now.isBetween(startTime, endTime)) {
          return true;
        } else {
          return false;
        }
      }
    },
  },

  methods: {
    IS_DIRECT_DOCTOR_ACCESS_ENABLED() {
      return (
        this.settings.patientAppSetting &&
        this.settings.patientAppSetting.directDoctorAccess &&
        this.settings.patientAppSetting.directDoctorAccess.enabled
      );
    },
    IS_MEDICINE_ORDER_ENABLED() {
      return (
        this.settings.patientAppSetting &&
        this.settings.patientAppSetting.medicineOrder &&
        this.settings.patientAppSetting.medicineOrder.enabled
      );
    },
    IS_LABTEST_BOOKING_ENABLED() {
      return (
        this.settings.patientAppSetting &&
        this.settings.patientAppSetting.labTestBooking &&
        this.settings.patientAppSetting.labTestBooking.enabled
      );
    },
    IS_MY_HEALTH_TAB_ENABLED() {
      return (
        this.settings.patientAppSetting &&
        this.settings.patientAppSetting.myHealthTab &&
        this.settings.patientAppSetting.myHealthTab.enabled
      );
    },
    async selectDoctorForBooking(id) {
      this.DOCTOR = await this.$store.dispatch("getUserById", id);
      this.SHOW_DOCTOR_MODAL = true;
    },
    handleNotificationLaunch(payload) {
      switch (payload.type) {
        case "vital":
          this.goToVitals();
          break;
        case "video":
          this.$router.push("videos");
          break;
        case "questionnaire":
          this.goToQuestionnaires();
          break;
        case "message":
          this.viewMessage(
            this.filteredMessages.find((m) => m._id == payload.messageId)
          );
          break;
      }
    },
    goToScheduleAppointments() {
      this.$router.push("/scheduleappointment?focussearch=true");
    },
    goToCounsultation() {
      this.changeAppHeaderText("appointments");
    },
    goToAdHocAppointment() {
      this.$router.push({ path: "/adhocappointment" });
    },
    onTabChange(label) {
      this.changeAppHeaderText(label);
    },
    IS_BLOG_FEED_ENABLED() {
      return (
        this.settings.patientAppSetting &&
        this.settings.patientAppSetting.blogFeed &&
        this.settings.patientAppSetting.blogFeed.enabled
      );
    },

    goToVitals() {
      if (this.user && this.user.endpoint) {
        this.$store.commit("setState", {
          stateName: "endpoint",
          stateValue: this.user.endpoint,
        });
      }
      this.$router.push({ path: "/patientvitals" });
    },
    goToQuestionnaires() {
      this.$router.push({ path: "/questionnaires/" + this.user.patientId });
    },
    async init() {
      this.getMessages();
      this.$store.dispatch("getQuestionnaireAnswers", this.user.patientId);
      await this.$store.dispatch("getSettings");

      if (this.careGroupDetails && this.careGroupDetails.cards) {
        this.CARECARDS_LOADED = true;
      } else {
        await this.$store.dispatch(
          "getCaregroup",
          this.user.caregroup._id || this.user.caregroup
        );
      }

      if (this.user.nursegroup) {
        this.nursegroup = await this.$store.dispatch(
          "getNursegroup",
          this.user.nursegroup._id || this.user.nursegroup
        );

        this.getRequestedServices();
        this.getScheduledAppointments();
      }

      await this.$store.dispatch("getAhcAppointments", this.user.patientId);
      await this.$store.dispatch("getHealthPackages");
    },
    initSocket() {
      //Join room with patient ID
      socket.emit("joinRoom", {
        type: "user",
        id: this.user._id,
        deviceToken: localStorage.firebaseToken,
      });

      socket.emit("joinRoom", {
        type: "other",
        id: this.user.patientId,
      });

      //Join room with endpoint name
      socket.emit("joinRoom", {
        type: "endpoint",
        id: this.user.endpoint.name,
      });

      //Join nursegroup room
      socket.emit("joinRoom", {
        type: "nursegroup",
        id: this.user.nursegroup,
        userId: this.user._id,
      });

      if (this.appointment && this.appointment._id) {
        //Join this appointment room
        socket.emit("joinRoom", {
          type: "appointment",
          id: this.appointment._id,
          userId: this.user._id,
        });
      }
    },

    checkAndRouteToNutritionPage() {
      // routing back to nutrition page if request was made from nutrition page
      if (this.$store.state.NutritionConsultation) {
        this.$store.commit("setState", {
          stateName: "NutritionConsultation",
          stateValue: false,
        });
        this.$router.push("nutritionhome");
      }
    },
    declineCarecoDiscailmer() {
      this.SHOW_CARECO_DISCLAIMER = false;
      this.checkAndRouteToNutritionPage();
    },
    async requestAppointment(appt) {
      this.goToCounsultation();
      let that = this;

      that.SHOW_CARECO_DISCLAIMER = false;
      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
      });
      if (this.user.caregroup) {
        try {
          if (appt) {
            this.appointment = appt;
          } else {
            this.appointment = {
              patient: {
                patientId: this.user.patientId,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                gender: this.user.gender,
                dob: this.user.dob,
                history: this.user.history,
              },
              questionnaire: "",
              attendant: {
                firstName: this.user.firstName,
                lastName: this.user.lastName,
              },
              appointmentStatus: [
                {
                  status: "Created",
                  timestamp: new Date().getTime(),
                },
              ],
              latestStatus: "Created",
              createdBy: "patient",
              appointmentType: "Live",
              endpoint: this.user.endpoint.name,
              consultationType: "telemedicine",
              preferredVideoCodec: "",
            };

            this.appointment.careCoordinator = {
              caregroupId: this.user.caregroup._id || this.user.caregroup,
            };

            this.appointment = await this.$store.dispatch(
              "requestAppointment",
              this.appointment
            );
          }

          socket.emit(
            "appointmentRequested",
            this.appointment.careCoordinator.caregroupId
          );

          this.$store.commit("setState", {
            stateName: "appointment",
            stateValue: this.appointment,
          });

          //Join this appointment room
          socket.emit("joinRoom", {
            type: "appointment",
            id: this.appointment._id,
            userId: this.user._id,
          });

          this.APPT_REQUESTED = true;

          if (
            !this.user.endpoint ||
            this.user.endpoint.videoConfEPType == "VMAATU_RTC"
          ) {
            // let instance = this.baseUrl
            //   .split("//")[1]
            //   .split(":")[0]
            //   .replace(/\./g, "_");

            //  room_name:
            //     this.instance +
            //     "_" +
            //     (this.appointment.latestStatus == "InProgress"
            //       ? this.baseUrl.split(":")[1].substr(2) + "_"
            //       : "") +
            //     this.appointment._id,

            this.simpleMeetingsQuery = {
              api_key: this.settings.vMaatuSettings.apikey,
              room_name: this.instance + "_" + this.appointment._id,
              user_name: this.user.username,
              tenant_name: this.user.tenant.name,
              controls: "true",
              video_encoding: this.appointment.preferredVideoCodec || "",
            };
          }

          socket.emit("appointmentCreated", {
            careCoordinatorId: this.appointment.careCoordinator.id,
            appointmentId: this.appointment._id,
          });
          loader.hide();
          this.$store.commit("setState", {
            stateName: "SHOW_TITLE_BAR",
            stateValue: false,
          });
          if (!appt) {
            swal.fire({
              title: this.$t("message.Appointment Requested"),
              text: this.$t("message.Your appointment request has been sent to Care coordinator. Please wait until his response."),
              type: "success",
              timer: 3000,
              showCloseButton: true,
            });
          }
        } catch (e) {
          loader.hide();
          console.log(e);

          if (
            e.response &&
            e.response.data &&
            e.response.data.message == "No Care Coordinator online"
          ) {
            swal.fire({
              title: this.$t("message.Sorry!"),
              text: this.$t("message.No Care Coordinators available. Please try after some time. In case of emergency call 1800 564 887"),
              type: "warning",
              showCloseButton: true,
            });
          }
        }
      } else {
        loader.hide();
        swal.fire({
          title: this.$t("message.Sorry!"),
          text: this.$t("message.Could not initiate the appointment. Contact Administrator"),
          type: "warning",
          showCloseButton: true,
        });
      }
    },
    showCareCoDisclaimer() {
      this.SHOW_APPOINTMENT_ACTION_BUTTONS = false;
      this.SHOW_CARECO_DISCLAIMER = true;
    },
    async docDisclaimerDisagree() {
      try {
        let providerId = this.appointment.provider.providerId;

        await this.$store.dispatch("updateStatus", {
          appointmentId: this.appointment._id,
          status: "Cancelled",
        });

        this.SHOW_DOCTOR_DISCLAIMER = false;
        this.appointment = null;
        this.APPT_REQUESTED = false;

        socket.emit("appointmentListUpdate", {
          providerId: providerId,
        });
        this.checkAndRouteToNutritionPage();
      } catch (e) {
        console.log(e);
      }
    },
    async cancelAppointment() {
      let _that = this;
      swal
        .fire({
          title: this.$t("message.Cancel Appointment"),
          text: this.$t("message.Are you sure that you want to cancel this request?"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: this.$t("message.Yes, Cancel"),
          cancelButtonText: this.$t("message.No"),
          closeOnConfirm: true,
        })
        .then(async (confirm) => {
          if (confirm.value) {
            await _that.$store.dispatch("updateStatus", {
              appointmentId: _that.appointment._id,
              status: "Cancelled",
            });

            if (this.$refs["webex-teams"]) {
              this.endWebexCall();
            }

            //Update care coordinator on appointment cancel
            socket.emit("appointmentRequestCancelled", {
              careCoordinatorId: _that.appointment.careCoordinator.id,
              appointmentId: _that.appointment._id,
            });
            _that.appointment = null;

            _that.$store.commit("setState", {
              stateName: "appointment",
              stateValue: _that.appointment,
            });

            _that.APPT_REQUESTED = false;
            _that.CARECO_JOINED = false;
            _that.getScheduledAppointments();
            this.checkAndRouteToNutritionPage();
          } else {
            swal.close();
          }
        });
    },

    //Messages
    async getMessages() {
      let response = await this.$store.dispatch("getMessages", {
        userId: this.user._id,
        pageNumber: this.messagesPagination.pageNumber,
      });
      this.messages = response.data;
      this.messagesPagination.totalPages = response.totalPages;
    },
    viewMessage(message) {
      this.$refs["message-badge"].$el.style.display = "none";
      this.unreadChatList.splice(this.unreadChatList.indexOf(message._id), 1);
      this.$store.state.message = message;
      this.$router.push("message");
    },
    selectMessage(message) {
      this.selectedMessage = message;
    },
    openNewMessageModal() {
      this.CREATE_NEW_MESSAGE = true;
    },

    selectDoctor(doctor) {
      this.selectedDoctor = doctor;
    },
    searchDoctor(searchString) {
      this.doctorSearchText = searchString;
      if (this.doctorList && this.doctorList.length) {
        this.filteredDoctorList = this.doctorList.filter((doctor) => {
          return (
            doctor.firstName.toLowerCase().indexOf(searchString.toLowerCase()) >
              -1 ||
            doctor.middleName
              .toLowerCase()
              .indexOf(searchString.toLowerCase()) > -1 ||
            doctor.lastName.toLowerCase().indexOf(searchString.toLowerCase()) >
              -1
          );
        });
      }
    },
    clearNewMessage() {
      this.selectedDoctor = null;
    },
    async startChat() {
      let message = {
        to: {
          id: this.selectedDoctor._id,
          firstName: this.selectedDoctor.firstName,
          lastName: this.selectedDoctor.lastName,
        },
        from: {
          id: this.user._id,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
        },
        subject: this.subject,
      };

      try {
        let messageThread = await this.$store.dispatch("startNewChat", message);
        this.$store.commit("setState", {
          stateName: "message",
          stateValue: messageThread,
        });
        this.$router.push("message");
      } catch (e) {
        console.log(e);
        swal.fire({
          title: this.$t("message.Could not start the chat"),
          text: this.$t("message.Contact Administrator"),
          type: "info",
        });
      }
    },

    async getScheduledAppointments($state) {
      if (!$state) {
        this.scheduledAppointments = [];
        this.scheduledApptPagiantion = {
          pageNumber: 1,
          totalPages: 0,
        };
      }
      let filter = {
        status: ["Created", "InProgress", "Assigned", "UnderReview", "Paused"],
        patientId: this.user.patientId,
        consultationType: { "＄ne": "teletraining" },
      };
      let _pageSize = Math.floor(screen.height / 136);
      let response = await this.$store.dispatch(
        "getLiveAndScheduledAppointments",
        {
          filter,
          pageNumber: this.scheduledApptPagiantion.pageNumber,
          pageSize: _pageSize,
        }
      );
      if (response.data && response.data.length) {
        this.scheduledAppointments.push(...response.data);
        this.scheduledApptPagiantion.totalPages = response.totalPages;
        this.scheduledApptPagiantion.pageNumber += 1;
        $state && $state.loaded();
      } else {
        $state && $state.complete();
      }

      for (let appt of this.scheduledAppointments) {
        if (
          appt.appointmentType == "Live" &&
          (appt.latestStatus == "Created" ||
            appt.latestStatus == "UnderReview") &&
          appt.careCoordinator // Select only get help now appointments
        ) {
          this.requestAppointment(appt);
          break;
        }
      }
    },
    async getCompletedAppointments($state) {
      console.log(
        "this.completedApptPagiantion.pageNumber",
        this.completedApptPagiantion.pageNumber
      );
      if (!$state) {
        this.completedAppointments = [];
        this.completedApptPagiantion = {
          pageNumber: 1,
          totalPages: 0,
        };
      }
      let filter = {
        status: ["Completed", "Postponed", "Declined"],
        patientId: this.user.patientId,
      };
      let _pageSize = Math.floor(screen.height / 136);
      let response = await this.$store.dispatch(
        "getLiveAndScheduledAppointments",
        {
          filter,
          pageNumber: this.completedApptPagiantion.pageNumber,
          pageSize: _pageSize,
        }
      );
      if (response.data && response.data.length) {
        this.completedAppointments.push(...response.data);
        this.completedApptPagiantion.totalPages = response.totalPages;
        this.completedApptPagiantion.pageNumber += 1;
        $state && $state.loaded();
      } else {
        $state && $state.complete();
      }
    },
    getFormattedDate(date) {
      return moment(date).format("MMM Do YYYY, hh:mm a");
    },
    async joinAppointment(appointment) {
      try {
        this.appointment = await this.$store.dispatch("updateStatusOnJoin", {
          appointmentId: appointment._id,
        });
        this.$store.commit("setState", {
          stateName: "appointment",
          stateValue: this.appointment,
        });

        if (this.appointment.provider && this.appointment.provider.providerId) {
          socket.emit("appointmentListUpdate", {
            providerId: this.appointment.provider.providerId,
          });
        }

        //For speciality appointments
        else if (this.appointment.specialityId) {
          socket.emit("appointmentListUpdate", {
            specialityId: this.appointment.specialityId,
          });
        }

        if (this.settings.directTelemedicine.consultancyParadigm == "chat") {
          let systemMessagesSent = false;
          for (let msg of this.appointmentMessages) {
            if (
              msg.content &&
              msg.content == this.$t("message.Use the chat messages to share as many details as possible with the doctor prior to the video consultation.")
            ) {
              systemMessagesSent = true;
              break;
            }
          }

          //Not sending system messages for speciality appointment as chat mode for speciality appointment is not thought through
          if (!systemMessagesSent && this.appointment.provider) {
            await this.sendSystemMessages();
          }
        }
        this.$router.push("telemed");
      } catch (e) {
        console.log(e);
      }
    },
    async viewAppointment(appointment) {
      if (appointment.createdBy != "patient") {
        let loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        try {
          let endpoint = await this.$store.dispatch(
            "getEndpointDetails",
            appointment.endpoint
          );
          let text =
            this.$t("message.Appointment is scheduled at") +
            " " +
            this.$t("message.nurse location") +
            " " +
            `(${appointment.endpoint})`;

          if (endpoint && endpoint.location && endpoint.location.name) {
            text =
              this.$t("message.Appointment is scheduled at") +
              " " +
              endpoint.location.name +
              ` (${appointment.endpoint})`;
          }
          loader.hide();
          swal.fire({
            type: "info",
            title: "",
            text: text,
            timer: 5000,
          });
        } catch (error) {
          loader.hide();
          swal.fire({
            type: "info",
            title: "",
            text:
              this.$t("message.Appointment is scheduled at") +
              " " +
              this.$t("message.nurse location"),
            timer: 5000,
          });
          console.log(error);
        }
        return;
      }

      if (appointment.consultationType == "inperson") {
        await this.$store.commit("setState", {
          stateName: "appointment",
          stateValue: appointment,
        });
        this.$router.push("waiting");
      } else {
        swal
          .fire({
            title: this.$t("message.bookings12"),
            text: this.$t("message.bookings11"),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: this.$t("message.filecard5"),
            cancelButtonText: this.$t("message.home34"),
            closeOnConfirm: true,
          })
          .then(async (result) => {
            if (result && result.value) {
              if (appointment.appointmentType == "Live") {
                this.joinAppointment(appointment);
              } else {
                if (appointment.latestStatus == "Created") {
                  let appoitnemntTime = moment(
                    parseInt(appointment.scheduledTimestamp.start)
                  );
                  let minutesRemainingToStart = appoitnemntTime.diff(
                    moment(),
                    "minutes"
                  );

                  //Allow to join 5 mins before to 10 mins after appointment scheduled time
                  if (
                    minutesRemainingToStart < 6 &&
                    minutesRemainingToStart > -61
                  ) {
                    this.joinAppointment(appointment);
                  } else {
                    swal.fire({
                      title: this.$t("message.patientHome9"),
                      text: this.$t("message.patientHome10", {
                        appointmentStart: this.getFormattedDate(
                          new Date(
                            parseInt(appointment.scheduledTimestamp.start)
                          )
                        ),
                      }),
                      timer: 4000,
                    });
                  }
                } else {
                  this.joinAppointment(appointment);
                }
              }
            }
          });
      }
    },
    viewAppointmentDetails(appointment) {
      this.$store.commit("setState", {
        stateName: "appointment",
        stateValue: appointment,
      });

      this.$router.push("viewappointmentdetails");
    },

    //AHC methods
    checkForAhcFeature() {
      if (this.settings && this.settings.healthCheckups) {
        this.$router.push("ahc");
      } else {
        // push only one notification at a time.
        const index = this.$notifications.state.findIndex(
          (n) => n.message === this.$t("message.patientHome1")
        );
        if (index < 0) {
          this.$notify({
            message: this.$t("message.patientHome1"),
            icon: "now-ui-icons travel_info",
            horizontalAlign: "center",
            verticalAlign: "bottom",
            type: "info",
          });
        }
      }
    },

    //Caregroup methods
    async getCaregroupDetails() {
      this.CARECARDS_LOADED = false;
      await this.$store.dispatch(
        "getCaregroup",
        this.user.caregroup._id || this.user.caregroup
      );
      this.CARECARDS_LOADED = true;
    },

    //Location tracking methods
    handleLocationtracking() {
      if (this.careGroupDetails.locationTracking.enabled) {
        BackgroundGeolocation.checkStatus(function (status) {
          console.log(
            "[INFO] BackgroundGeolocation service is running",
            status.isRunning
          );
          console.log(
            "[INFO] BackgroundGeolocation services enabled",
            status.locationServicesEnabled
          );
          console.log(
            "[INFO] BackgroundGeolocation auth status: " + status.authorization
          );

          if (!status.locationServicesEnabled) {
            swal
              .fire({
                title: this.$t("message.home50"),
                text: this.$t("message.home51"),
                type: "info",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                closeOnConfirm: true,
              })
              .then((confirm) => {
                if (confirm.value) {
                  BackgroundGeolocation.showLocationSettings();
                }
              });
          }

          if (!status.isRunning) {
            BackgroundGeolocation.start();
          }
        });
      } else {
        BackgroundGeolocation.checkStatus(function (status) {
          console.log(
            "[INFO] BackgroundGeolocation service is running",
            status.isRunning
          );
          console.log(
            "[INFO] BackgroundGeolocation services enabled",
            status.locationServicesEnabled
          );
          console.log(
            "[INFO] BackgroundGeolocation auth status: " + status.authorization
          );

          if (!status.locationServicesEnabled) {
            swal
              .fire({
                title: this.$t("message.home50"),
                text: this.$t("message.home51"),
                type: "info",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                closeOnConfirm: true,
              })
              .then((confirm) => {
                if (confirm.value) {
                  BackgroundGeolocation.showLocationSettings();
                }
              });
          }

          if (status.isRunning) {
            BackgroundGeolocation.stop();
          }
        });
      }
    },

    //Nurse calling
    async requestService(service) {
      if (this.isRequestedService(service)) {
        swal
          .fire({
            type: "info",
            title: "Are you sure to cancel this request",
            text: "This action cannot be undone",
            showCancelButton: true,
            confirmButtonText: "Cancel",
            cancelButtonText: "Discard",
          })
          .then(async (result) => {
            if (result && result.value) {
              let requestToCancel = this.requestedServices.filter(
                (requestedService) => {
                  return (
                    requestedService.latestStatus == "Created" &&
                    requestedService.service.name == service.name
                  );
                }
              );

              let response = await this.$store.dispatch(
                "cancelServiceRequest",
                requestToCancel[0]._id
              );

              if (response) {
                swal.fire({
                  type: "success",
                  title: this.$t("message.patientHome14"),
                  timer: 3000,
                });

                socket.emit("nurseCallingUpdate", {
                  nursegroupId: this.nursegroup._id,
                  userId: this.user._id,
                });
                this.getRequestedServices();
              } else {
                swal.fire({
                  type: "warning",
                  title: this.$t("message.patientHome15"),
                  timer: 3000,
                });
              }
            }
          });
      } else {
        let serviceRequest = await this.$store.dispatch("requestService", {
          service,
          patientId: this.user.patientId,
          nursegroupId: this.nursegroup._id,
        });

        if (serviceRequest) {
          swal.fire({
            type: "success",
            title: this.$t("message.patientHome16"),
            timer: 3000,
          });
          socket.emit("nurseCallingUpdate", {
            nursegroupId: this.nursegroup._id,
            userId: this.user._id,
          });
          this.getRequestedServices();
        }
      }
    },
    isRequestedService(service) {
      let matchedServices = this.requestedServices.filter(
        (requestedService) => {
          return (
            requestedService.latestStatus == "Created" &&
            requestedService.service.name == service.name
          );
        }
      );

      if (matchedServices.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isAcceptedService(service) {
      let matchedServices = this.requestedServices.filter(
        (requestedService) => {
          return (
            requestedService.latestStatus == "InProgress" &&
            requestedService.service.name == service.name
          );
        }
      );

      if (matchedServices.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    async getRequestedServices() {
      let response = await this.$store.dispatch(
        "getRequestedServices",
        this.user.patientId
      );

      this.requestedServices = response.data;
    },

    //Webex Teams
    async endWebexCall() {
      try {
        await this.$refs[
          "webex-teams"
        ].simpleMeetingsWebex.webexManager.endCall();
      } catch (err) {
        console.log("Error in ending webex call", err);
      }
    },
    async onCallAccepted() {
      let that = this;
      this.callNotification = false;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.appointment._id,
        status: "accepted",
      });

      if (response && response._id) {
        let message = {
          username: this.incomingCallAppt.patient.patientId,
          status: "accepted",
        };
        socket.emit("newChatMessage", {
          appointmentId: this.incomingCallAppt._id,
          chatMessage: message,
        });
        this.joinAppointment(this.incomingCallAppt);
      }
    },
    async sendSystemMessages() {
      let newMessage = {
        username: this.appointment.provider.username,
        name: `${this.appointment.provider.firstName} ${this.appointment.provider.lastName}`,
        content: this.$t("message.patientHome17"),
        time: moment().format("MMMM Do YYYY, h:mm a"),
        type: "system",
      };
      let newMessage2 = {
        username: this.appointment.provider.username,
        name: `${this.appointment.provider.firstName} ${this.appointment.provider.lastName}`,
        content: this.$t("message.patientHome18"),
        time: moment().format("MMMM Do YYYY, h:mm a"),
        type: "system",
      };
      let newMessage3 = {
        username: this.appointment.provider.username,
        name: `${this.appointment.provider.firstName} ${this.appointment.provider.lastName}`,
        content: this.$t("message.patientHome19"),
        time: moment().format("MMMM Do YYYY, h:mm a"),
        type: "system",
      };
      let newMessage4 = {
        username: this.appointment.provider.username,
        name: `${this.appointment.provider.firstName} ${this.appointment.provider.lastName}`,
        content: this.$t("message.patientHome20"),
        time: moment().format("MMMM Do YYYY, h:mm a"),
        type: "system",
      };
      let newMessage5 = {
        username: this.appointment.provider.username,
        name: `${this.appointment.provider.firstName} ${this.appointment.provider.lastName}`,
        content: this.$t("message.patientHome21"),
        time: moment().format("MMMM Do YYYY, h:mm a"),
        type: "system",
      };
      await this.$store.dispatch("updateMessages", {
        appointmentId: this.appointment._id,
        newMesssage: newMessage,
      });
      await this.$store.dispatch("updateMessages", {
        appointmentId: this.appointment._id,
        newMesssage: newMessage2,
      });
      await this.$store.dispatch("updateMessages", {
        appointmentId: this.appointment._id,
        newMesssage: newMessage3,
      });
      if (this.appointment.appointmentType != "Live") {
        await this.$store.dispatch("updateMessages", {
          appointmentId: this.appointment._id,
          newMesssage: newMessage4,
        });
      }
      await this.$store.dispatch("updateMessages", {
        appointmentId: this.appointment._id,
        newMesssage: newMessage5,
      });
    },
    onCallMissed() {
      this.callNotification = false;
      socket.emit("leaveRoom", {
        type: "appointment",
        id: this.incomingCallAppt._id,
        userId: this.user._id,
      });
    },
    async onCallDeclined() {
      this.callNotification = false;
      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.appointment._id,
        status: "declined",
      });
      if (response && response._id) {
        let message = {
          username: this.incomingCallAppt.patient.patientId,
          status: "declined",
        };
        socket.emit("newChatMessage", {
          appointmentId: this.incomingCallAppt._id,
          chatMessage: message,
        });
        socket.emit("leaveRoom", {
          type: "appointment",
          id: this.incomingCallAppt._id,
          userId: this.user._id,
        });
      }
    },
    async onCallPushNotification(payload) {
      let that = this;
      that.incomingCallAppt = await that.$store.dispatch(
        "getAppointment",
        payload.appointmentId
      );
      //Get appointment messages
      if (that.incomingCallAppt) {
        let response = await that.$store.dispatch(
          "getAppointmentMessages",
          that.incomingCallAppt._id
        );
        that.appointmentMessages = response;
      }

      for (let i = that.appointmentMessages.length - 1; i >= 0; i--) {
        if (
          that.appointmentMessages[i].content &&
          that.appointmentMessages[i].content == "Video call"
        ) {
          if (that.appointmentMessages[i].status == "initiated") {
            that.caller.img = avatarImage;
            that.caller.name =
              "Dr. " +
              that.incomingCallAppt.provider.firstName +
              " " +
              that.incomingCallAppt.provider.lastName;
            that.callNotification = true;

            socket.emit("joinRoom", {
              type: "appointment",
              id: that.incomingCallAppt._id,
              userId: that.user._id,
            });
          } else {
            that.joinAppointment(that.incomingCallAppt);
          }
          break;
        }
      }
    },
  },

  beforeMount() {
    if (this.careGroupDetails && this.careGroupDetails.cards) {
      this.CARECARDS_LOADED = true;
    }
  },

  async mounted() {
    let that = this;
    that.getScheduledAppointments();

    this.$root.onBackButton = () => {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      } else if (this.APPT_REQUESTED) {
        this.cancelAppointment();
      } else {
        swal
          .fire({
            title: this.$t("message.telemed4"),
            confirmButtonText: this.$t("message.telemed6"),
            showCancelButton: true,
            cancelButtonText: this.$t("message.telemed7"),
          })
          .then(async (result) => {
            if (result && result.value) {
              navigator.app.exitApp();
            }
          });
      }
    };

    window.onAppResume = () => {
      setTimeout(() => {
        this.init();

        if (
          this.locationTrackingEnabled &&
          this.careGroupDetails &&
          this.careGroupDetails.locationTracking &&
          this.careGroupDetails.locationTracking.basicAuth &&
          this.careGroupDetails.locationTracking.basicAuth.username &&
          this.careGroupDetails.locationTracking.basicAuth.password
        ) {
          this.handleLocationtracking();
        }
      }, 0);
    };

    if (this.$route.params.showCarecoDisclaimer) {
      this.SHOW_CARECO_DISCLAIMER = true;
    }

    if (this.user) {
      try {
        let user = await this.$store.dispatch("getUserById", this.user._id);

        this.$store.commit("setState", {
          stateName: "patient",
          stateValue: user,
        });

        try {
          let userEndpoint = await this.$store.dispatch(
            "getEndpointByDeviceType",
            this.user._id
          );

          this.$store.commit("setState", {
            stateName: "endpoint",
            stateValue: userEndpoint,
          });

          if (userEndpoint && userEndpoint._id) {
            user.endpoint = userEndpoint;
          }
        } catch (e) {
          console.log(e);
        }

        // previous appointment doctors
        if (!user.myDoctors || user.myDoctors.length == 0) {
          this.previousAppointmentDoctors = await this.$store.dispatch(
            "getPreviousAppointmentDoctors",
            {
              userId: user._id,
            }
          );
        }

        localStorage.user = JSON.stringify(user);
        this.user = user; // added to update user details since localstorage is not reactive
      } catch (e) {
        console.log(e);
      }

      await this.init();

      if (that.FCMpayload) {
        if (
          that.FCMpayload.type == "callNotification" &&
          that.FCMpayload.appointmentId
        ) {
          that.onCallPushNotification(that.FCMpayload);
        }

        if (that.FCMpayload.type) {
          that.handleNotificationLaunch(that.FCMpayload);
        }
        that.$store.state.FCMpayload = null;
      }

      //Configure location background service
      if (
        this.locationTrackingEnabled &&
        this.careGroupDetails &&
        this.careGroupDetails.locationTracking &&
        this.careGroupDetails.locationTracking.basicAuth &&
        this.careGroupDetails.locationTracking.basicAuth.username &&
        this.careGroupDetails.locationTracking.basicAuth.password
      ) {
        try {
          BackgroundGeolocation.configure({
            locationProvider: BackgroundGeolocation.ACTIVITY_PROVIDER,
            desiredAccuracy: BackgroundGeolocation.HIGH_ACCURACY,
            stationaryRadius:
              this.careGroupDetails.locationTracking.parameters
                .stationaryRadius || 50,
            distanceFilter:
              this.careGroupDetails.locationTracking.parameters
                .distanceFilter || 50,
            notificationTitle: this.$t("message.home52"),
            notificationText: this.$t("message.home53"),
            debug: false,
            interval: 1000,
            fastestInterval: 1000,
            activitiesInterval:
              this.careGroupDetails.locationTracking.parameters
                .activitiesInterval || 10000,
            stopOnTerminate:
              this.careGroupDetails.locationTracking.parameters
                .stopOnTerminate || false,
            startOnBoot:
              this.careGroupDetails.locationTracking.parameters.startOnBoot ||
              true,
            startForeground: true,
            maxLocations: 1000,
            url: this.baseUrl + "/userlocations/app/track",
            httpHeaders: {
              Authorization:
                "Basic " +
                btoa(
                  unescape(
                    encodeURIComponent(
                      this.careGroupDetails.locationTracking.basicAuth
                        .username +
                        ":" +
                        this.careGroupDetails.locationTracking.basicAuth
                          .password
                    )
                  )
                ),
            },
            postTemplate: {
              lat: "@latitude",
              lon: "@longitude",
              tenantId: this.user.tenant._id,
              userId: this.user._id,
              caregroupId: this.careGroupDetails._id,
              deviceId: localStorage.deviceId,
            },
          });

          BackgroundGeolocation.removeAllListeners();

          BackgroundGeolocation.on("location", async function (location) {
            console.log("location", location);

            if (device && device.platform == "iOS") {
              BackgroundGeolocation.startTask(async function (taskKey) {
                await that.$store.dispatch("saveLocationUpdates", {
                  lat: location.latitude,
                  lon: location.longitude,
                  tenantId: that.user.tenant._id,
                  userId: that.user._id,
                  deviceId: localStorage.deviceId,
                });

                BackgroundGeolocation.endTask(taskKey);
              });
            }

            await that.$store.dispatch("getCurrentLocation", {
              latitude: location.latitude,
              longitude: location.longitude,
              locale: that.$i18n.locale,
            });
          });

          BackgroundGeolocation.on(
            "stationary",
            async function (stationaryLocation) {
              console.log("stationary", stationaryLocation);

              await that.$store.dispatch("getCurrentLocation", {
                latitude: stationaryLocation.latitude,
                longitude: stationaryLocation.longitude,
                locale: that.$i18n.locale,
              });
            }
          );

          BackgroundGeolocation.on("error", function (error) {
            console.log(
              "[ERROR] BackgroundGeolocation error:",
              error.code,
              error.message
            );
          });

          BackgroundGeolocation.on("start", function () {
            console.log(
              "[INFO] BackgroundGeolocation service has been started"
            );
          });

          BackgroundGeolocation.on("stop", function () {
            console.log(
              "[INFO] BackgroundGeolocation service has been stopped"
            );
          });

          BackgroundGeolocation.on("authorization", function (status) {
            console.log(
              "[INFO] BackgroundGeolocation authorization status: " + status
            );
            if (status !== BackgroundGeolocation.AUTHORIZED) {
              // we need to set delay or otherwise alert may not be shown
              setTimeout(function () {
                var showSettings = confirm(
                  "App requires location tracking permission. Would you like to open app settings?"
                );
                if (showSettings) {
                  return BackgroundGeolocation.showAppSettings();
                }
              }, 1000);
            }
          });

          BackgroundGeolocation.on("background", function () {
            console.log("[INFO] App is in background");
          });

          BackgroundGeolocation.on("foreground", function () {
            console.log("[INFO] App is in foreground");
          });

          BackgroundGeolocation.on("abort_requested", function () {
            console.log(
              "[INFO] Server responded with 285 Updates Not Required"
            );

            // Here we can decide whether we want stop the updates or not.
            // If you've configured the server to return 285, then it means the server does not require further update.
            // So the normal thing to do here would be to `BackgroundGeolocation.stop()`.
            // But you might be counting on it to receive location updates in the UI, so you could just reconfigure and set `url` to null.
          });

          BackgroundGeolocation.on("http_authorization", () => {
            console.log("[INFO] App needs to authorize the http requests");
          });

          this.handleLocationtracking();
        } catch (e) {
          console.eror("Error in ititializing location tracking service", e);
        }
      }

      //Adding wait to show loader
      await setTimeout(() => {
        if (this.careGroupDetails) {
          this.CARECARDS_LOADED = true;
        }
      }, 2000);

      setTimeout(() => {
        if (that.messages) {
          that.$store.state.message = that.selectedMessage = that.messages[0];
        }
      }, 2000);

      //Socket listeners
      socket.on("appointmentPostponed", async (data) => {
        this.getScheduledAppointments();
      });
      socket.on("appointmentDeclined", async (data) => {
        this.getScheduledAppointments();
      });
      socket.on("appointmentJoined", async (data) => {
        this.getScheduledAppointments();
      });
      socket.on("appointmentPaused", async (data) => {
        this.getScheduledAppointments();
      });
      socket.on("appointmentReviewed", async (data) => {
        this.appointmentId = data.appointmentId;

        //Get updated requested appointment's data
        this.appointment = await this.$store.dispatch(
          "getAppointment",
          this.appointmentId
        );

        this.$store.commit("setState", {
          stateName: "appointment",
          stateValue: this.appointment,
        });
        var msg = this.$t("message.home37");

        if (this.$refs["webex-teams"]) {
          this.endWebexCall();
        } else if (this.$refs.vmaatu) {
          this.$refs.vmaatu.destroy();
        }

        if (this.appointment.appointmentType == "Live") {
          if (data.specialityName) {
            msg =
              msg +
              this.$t("message.home38") +
              "<b> " +
              data.specialityName +
              "</b>";
          } else {
            msg =
              msg +
              "<br><b>" +
              this.$t("message.home8") +
              this.appointment.provider.firstName +
              " " +
              this.appointment.provider.lastName +
              "</b>";
          }

          swal
            .fire({
              title: this.$t("message.home40"),
              type: "success",
              html: msg,
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: this.$t("message.home41"),
              closeOnConfirm: true,
              timer: 10000,
            })
            .then(async () => {
              swal.close();

              if (this.settings.disclaimerText) {
                this.SHOW_DOCTOR_DISCLAIMER = true;
              } else {
                await this.sendSystemMessages();
                this.$router.push("telemed");
              }
            });
        } else {
          // $scope.getScheduledAppts($scope.filterDate);

          swal
            .fire({
              title: this.$t("message.patientHome11"),
              text: this.$t("message.patientHome12", {
                appointmentDate: moment(
                  parseInt(this.appointment.scheduledTimestamp.start)
                ).format("MMMM Do YYYY"),
                appointmentTime: moment(
                  parseInt(this.appointment.scheduledTimestamp.start)
                ).format("hh:mm a"),
                providerFirstName: this.appointment.provider.firstName,
                providerLastName: this.appointment.provider.lastName,
              }),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              closeOnConfirm: true,
              timer: 10000,
            })
            .then(() => {
              this.APPT_REQUESTED = false;
              this.CARECO_JOINED = false;
              this.getScheduledAppointments();
              this.checkAndRouteToNutritionPage();
            });
        }
      });

      socket.on("appointmentRequestAttended", async (appointmentId) => {
        if (
          that.appointment &&
          that.appointment._id &&
          that.appointment._id == appointmentId
        ) {
          that.appointment = await that.$store.dispatch(
            "getAppointment",
            appointmentId
          );

          //Generate room url for Webex endpoints
          if (
            this.user.endpoint.videoConfEPType == "SPARK_EMBEDDED" ||
            this.user.endpoint.videoConfEPType == "WEBEXTEAMS_GUEST"
          ) {
            let webexTokens = await that.$store.dispatch(
              "getValidWebexGuestAccessToken"
            );

            if (webexTokens) {
              this.simpleMeetingsQuery = {
                api_key: this.settings.vMaatuSettings.apikey,
                room_name: this.instance + "_" + that.appointment._id + "_cc",
                user_name: this.user.username,
                tenant_name: this.user.tenant.name,
                access_token: webexTokens.accessToken,
                destination: that.appointment.webexTeams.roomId,
              };
            } else {
              localStorage.setItem("user", null);
              that.$router.push("signin");
            }
          }
          that.CARECO_JOINED = true;

          if (this.user.endpoint.videoConfEPType == "VMAATU_RTC") {
            setTimeout(() => {
              that.$refs.vmaatu.init();
            }, 1000);
          }
        } else {
          that.CARECO_JOINED = false;
          that.$refs.vmaatu.destroy();
        }
      });

      socket.on("appointmentRequestPaused", async (appointmentId) => {
        if (
          that.appointment &&
          that.appointment._id &&
          that.appointment._id == appointmentId
        ) {
          that.CARECO_JOINED = false;
          that.$refs.vmaatu.destroy();
        }
      });

      socket.on("appointmentDeclined", async () => {
        this.appointment = null;

        this.$store.commit("setState", {
          stateName: "appointment",
          stateValue: this.appointment,
        });

        this.APPT_REQUESTED = false;
        this.CARECO_JOINED = false;

        if (this.$refs.vmaatu) this.$refs.vmaatu.destroy();

        swal.fire({
          title: this.$t("message.home46"),
          text: this.$t("message.home47"),
          type: "warning",
          showCloseButton: true,
          timer: 4000,
        });

        this.getScheduledAppointments();
        this.checkAndRouteToNutritionPage();
      });

      socket.on("newMessage", async (data) => {
        if (data.toUser == that.user._id) {
          this.getMessages();
          that.$refs["message-badge"].$el.style.display = "inline-block";
          that.unreadChatList.push(data.messageId);
        }
      });

      socket.on("appointmentListUpdate", () => {
        that.getScheduledAppointments();
      });

      socket.on("appointmentExit", async (data) => {
        this.getScheduledAppointments();
      });
      this.initSocket();
      window.initSocket = this.initSocket;

      //Nurse calling sockets
      socket.on("nurseCallingUpdate", (data) => {
        if (data.userId != this.user._id) {
          this.getRequestedServices();
        }
      });

      socket.on("newChatMessage", async (message) => {
        if (
          message.chatMessage.username !=
          this.incomingCallAppt.patient.patientId
        ) {
          if (
            message.chatMessage.status &&
            message.chatMessage.status == "cancelled"
          ) {
            this.callNotification = false;
            socket.emit("leaveRoom", {
              type: "appointment",
              id: this.incomingCallAppt._id,
              userId: this.user._id,
            });
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "missed"
          ) {
            this.callNotification = false;
            socket.emit("leaveRoom", {
              type: "appointment",
              id: this.incomingCallAppt._id,
              userId: this.user._id,
            });
          }
        }
      });

      if (this.user && this.user.endpoint) {
        let response = await this.$store.dispatch(
          "getConfigurationByEndpointId",
          {
            endpointId: this.user.endpoint._id,
            type: "deviceProfile",
          }
        );
        if (response && response.value) {
          this.deviceProfile = response.value;
        }
      }
    } else {
      console.log("no user");
      this.$router.push({ path: "/signin" });
    }
    console.log("caregroup", this.$store.state.caregroup);
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
    socket.off("appointmentReviewed");
    socket.off("appointmentRequestAttended");
    socket.off("appointmentDeclined");
    socket.off("newMessage");
    socket.off("nurseCallingUpdate");
    window.initSocket = null;

    //Leaving room to avoid listening to endpoint room messages even after leaving the page
    socket.emit("leaveRoom", {
      type: "endpoint",
      id: this.endpoint.name,
      userId: this.user._id,
    });
  },

  watch: {
    "messagesPagination.pageNumber": function () {
      this.getMessages();
    },
  },
};
</script>

<style scoped>
/* #home {
      margin-top: 1em;
  } */
#home .stats {
  text-align: center;
}

.search-block {
  background-color: white;
  padding-top: 1em;
  padding-right: 2em;
  padding-left: 2em;
  margin-left: -2em;
  margin-right: -2em;
  padding-bottom: 6px;
}

.not-found-img {
  width: 100%;
}

.card-header-nav {
  background: var(--color-primary);
}

.card-header-nav .nav-pills > li > a > div {
  color: #fff;
}

.card-header-nav .nav-pills.nav-pills-neutral .nav-item .nav-link {
  background-color: transparent !important;
  box-shadow: none;
}

#home .tab-content.tab-subcategories {
  width: 100%;
}

.main-panel > .content {
  margin-top: 0px;
}

.nav-pills.nav-pills:not(.flex-column) .nav-item:not(:last-child) .nav-link {
  margin-right: 8px;
}

.icon .nav-link {
  padding: 0px 15px !important;
}

.tab-no-space {
  padding-top: 0px !important;
}
</style>

<style scoped>
.appointments-action-button {
  padding-top: 1em;
  padding-bottom: 1em;
  border-bottom: 1px solid #0000001f;
}

.appointments-action-button > .row {
  display: flex;
  align-items: center;
  width: 100%;
}

.appointments-action-button .fa {
  font-size: 1.2em;
}

.appointments-action-button h6 {
  margin-bottom: 0;
  font-weight: 500;
  text-transform: none;
  font-size: 1.1em;
}

/deep/.appointments-action-modal:not(.d-none) {
  display: flex !important;
  align-items: end;
  justify-content: center;
}

/deep/.appointments-action-modal .modal-dialog {
  width: 100%;
  margin: 0;
  border-top-right-radius: 24px;
  border-top-left-radius: 24px;
  overflow: hidden;
  max-width: none;
}

/deep/.appointments-action-modal-content {
  /* height: 98vh; */
}

/deep/.patient-appointments-tabs {
  height: 100%;
}

/deep/.patient-appointments-tabs .tab-content {
  height: calc(100% - 30px);
}

/deep/.patient-appointments-tabs .tab-space {
  /* padding: 0px; */
  padding-top: 2em;
  padding-bottom: 0;
}

/deep/ .patient-appointments-tabs a.nav-link span {
  font-size: 0.9em;
}

/deep/ .patient-appointments-tabs li {
  margin-left: 1em;
  margin-right: 1em;
}

/deep/ .patient-appointments-tabs .nav-pills .nav-item .nav-link.active,
.nav-pills .nav-item .nav-link.active:focus,
.nav-pills .nav-item .nav-link.active:hover {
  box-shadow: 0px 5px 13px 0px rgb(0 0 0 / 30%);
}

/deep/ .illustration-tabs ul.nav.nav-pills {
  justify-content: space-evenly;
}

/deep/ .illustration-tabs .nav-pills .nav-item .nav-link {
  padding: 10px 22px;
  /* border: 1px solid; */
}

.custom-input.IZ-select {
  height: 3em;
  overflow: hidden;
}

[dir="rtl"] #order-lab-card {
  transform: scaleX(-1);
}

[dir="rtl"] #order-med-card {
  transform: scaleX(-1);
}

[dir="rtl"] #order-med-card .card-text {
  transform: scaleX(-1);
}

[dir="rtl"] #order-med-card .card-title {
  transform: scaleX(-1);
}

[dir="rtl"] #order-lab-card .card-title {
  transform: scaleX(-1);
}

[dir="rtl"] #order-lab-card .card-text {
  transform: scaleX(-1);
}

#get-help {
  background-image: url("../../assets/img/medicalnurse.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position-x: right;
  padding-bottom: 2em;
}

[dir="rtl"] #get-help {
  background-position-x: left;
}

/deep/.cancel-appt-request-button {
  z-index: 100;
}

.video-call-wrapper {
  width: 100%;
  position: fixed;
  top: 0px;
  bottom: 0px;
  inset-inline-end: 0px;
  height: 100vh;
  z-index: 1030;
  background-color: #f1f1f1;
}

.ios .video-call-wrapper {
  height: 100vh;
}

/deep/ .nav-pills .nav-item .nav-link {
  min-width: 64px;
}

/deep/.nav-pills .nav-item {
  flex: 1;
}

#care-card-front,
.care-card-description {
  height: 18em;
}

.care-card-description {
  overflow: scroll;
}

.image-text-overlay {
  font-size: 0.7em;
}

.appointments-wrapper {
  margin-top: 1em;
}

.icon.icon-circle {
  width: 65px;
  height: 65px;
  /* max-width: 65px; */
  margin: auto;
  /* margin-top: 8px; */
  border-radius: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon.icon-circle i {
  display: table;
  /* margin: 0 auto; */
  /* line-height: 2.8; */
  font-size: 25px;
}

.link-label {
  margin-top: 1em;
  display: block;
}

.link-section {
  margin-top: 0.5em;
  padding-top: 1.5em;
  border-top: 1px solid #dcd7d7;
}

/deep/ .tab-content {
  height: 100%;
  /* Commented to make absolute positioned elements to be relative to .main-panel */
  /* position: relative; */
}

.content > div,
.content > div > div {
  height: 100%;
}

.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
}

.message-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.message-list:first-child {
  border-top: none;
}

.message-list.selected {
  background-color: whitesmoke;
}

.message-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}

.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}

.icon.icon-circle img {
  padding: 20px;
}

/deep/ .sc-chat-window {
  max-height: 100%;
  inset-inline-end: 0px;
  bottom: 0px;
  width: 100%;
  height: 78vh;
}

/deep/ .sc-message {
  width: 90%;
}

/deep/ .sc-header {
  display: none;
}

/deep/ .sc-launcher.opened {
  display: none;
}

/deep/ .VueCarousel-dot-container {
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot:focus {
  outline: none !important;
}

.boxes {
  --size: 32px;
  --duration: 800ms;
  height: calc(var(--size) * 2);
  width: calc(var(--size) * 3);
  position: relative;
  transform-style: preserve-3d;
  transform-origin: 50% 50%;
  margin-top: calc(var(--size) * 1.5 * -1);
  transform: rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px);
}

.boxes .box {
  width: var(--size);
  height: var(--size);
  top: 0;
  left: 0;
  position: absolute;
  transform-style: preserve-3d;
}

.boxes .box:nth-child(1) {
  transform: translate(100%, 0);
  animation: box1 var(--duration) linear infinite;
}

.boxes .box:nth-child(2) {
  transform: translate(0, 100%);
  animation: box2 var(--duration) linear infinite;
}

.boxes .box:nth-child(3) {
  transform: translate(100%, 100%);
  animation: box3 var(--duration) linear infinite;
}

.boxes .box:nth-child(4) {
  transform: translate(200%, 0);
  animation: box4 var(--duration) linear infinite;
}

.boxes .box > div {
  --background: #45b2fe;
  --top: auto;
  --inset-inline-end: auto;
  --bottom: auto;
  --left: auto;
  --translateZ: calc(var(--size) / 2);
  --rotateY: 0deg;
  --rotateX: 0deg;
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--background);
  top: var(--top);
  inset-inline-end: var(--right);
  bottom: var(--bottom);
  left: var(--left);
  transform: rotateY(var(--rotateY)) rotateX(var(--rotateX))
    translateZ(var(--translateZ));
}

.boxes .box > div:nth-child(1) {
  --top: 0;
  --left: 0;
}

.boxes .box > div:nth-child(2) {
  --background: #369ae0;
  --inset-inline-end: 0;
  --rotateY: 90deg;
}

.boxes .box > div:nth-child(3) {
  --background: #aadcff;
  --rotateX: -90deg;
}

.boxes .box > div:nth-child(4) {
  --background: #dbe3f4;
  --top: 0;
  --left: 0;
  --translateZ: calc(var(--size) * 3 * -1);
}

@keyframes box1 {
  0%,
  50% {
    transform: translate(100%, 0);
  }

  100% {
    transform: translate(200%, 0);
  }
}

@keyframes box2 {
  0% {
    transform: translate(0, 100%);
  }

  50% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(100%, 0);
  }
}

@keyframes box3 {
  0%,
  50% {
    transform: translate(100%, 100%);
  }

  100% {
    transform: translate(0, 100%);
  }
}

@keyframes box4 {
  0% {
    transform: translate(200%, 0);
  }

  50% {
    transform: translate(200%, 100%);
  }

  100% {
    transform: translate(100%, 100%);
  }
}

html {
  -webkit-font-smoothing: antialiased;
}

* {
  box-sizing: border-box;
}

*:before,
*:after {
  box-sizing: border-box;
}

body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fbff;
}

body .dribbble {
  position: fixed;
  display: block;
  inset-inline-end: 20px;
  bottom: 20px;
}

body .dribbble img {
  display: block;
  height: 28px;
}

@media (min-width: 768px) {
  #care-card-front,
  .care-card-description {
    height: 24em;
  }
}

@media (min-width: 992px) {
  #care-card-front,
  .care-card-description {
    height: 22em;
  }
}

@media (max-height: 667px) {
  #care-card-front,
  .care-card-description {
    height: 11em;
  }
}

@media (min-height: 768px) {
  /deep/ .sc-chat-window {
    height: 74vh;
  }
}

@media (min-height: 1024px) {
  /deep/ .sc-chat-window {
    height: 81vh;
  }
}

.la-ball-scale-multiple,
.la-ball-scale-multiple > div {
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.la-ball-scale-multiple {
  display: block;
  font-size: 0;
  color: #fff;
}

.la-ball-scale-multiple.la-dark {
  color: #333;
}

.la-ball-scale-multiple > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.la-ball-scale-multiple {
  width: 32px;
  height: 32px;
}

.la-ball-scale-multiple > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  opacity: 0;
  -webkit-animation: ball-scale-multiple 1s 0s linear infinite;
  -moz-animation: ball-scale-multiple 1s 0s linear infinite;
  -o-animation: ball-scale-multiple 1s 0s linear infinite;
  animation: ball-scale-multiple 1s 0s linear infinite;
}

.la-ball-scale-multiple > div:nth-child(2) {
  -webkit-animation-delay: 0.2s;
  -moz-animation-delay: 0.2s;
  -o-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.la-ball-scale-multiple > div:nth-child(3) {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  -o-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.la-ball-scale-multiple.la-sm {
  width: 16px;
  height: 16px;
}

.la-ball-scale-multiple.la-sm > div {
  width: 16px;
  height: 16px;
}

.la-ball-scale-multiple.la-2x {
  width: 64px;
  height: 64px;
}

.la-ball-scale-multiple.la-2x > div {
  width: 64px;
  height: 64px;
}

.la-ball-scale-multiple.la-3x {
  width: 96px;
  height: 96px;
}

.la-ball-scale-multiple.la-3x > div {
  width: 96px;
  height: 96px;
}

/*
 * Animation
 */
@-webkit-keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  5% {
    opacity: 0.75;
  }

  100% {
    opacity: 0;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@-moz-keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -moz-transform: scale(0);
    transform: scale(0);
  }

  5% {
    opacity: 0.75;
  }

  100% {
    opacity: 0;
    -moz-transform: scale(1);
    transform: scale(1);
  }
}

@-o-keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -o-transform: scale(0);
    transform: scale(0);
  }

  5% {
    opacity: 0.75;
  }

  100% {
    opacity: 0;
    -o-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes ball-scale-multiple {
  0% {
    opacity: 0;
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -o-transform: scale(0);
    transform: scale(0);
  }

  5% {
    opacity: 0.75;
  }

  100% {
    opacity: 0;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}

/deep/.tab-pane.active {
  overflow-x: hidden !important;
}

/deep/.my-doctor-card .modal-body {
  margin-top: 2em !important;
}
</style>
